export enum UserWorkspaceRolesEnum {
  workspaceAdmin = 'role_admin',
  workspaceAssistant = 'role_assistant',
}
